;
define("facets_facets_display.tpl", function(){});

